import type { SubscriptionTier, MarginTier } from "./types";
import { STRIPE_BASE_PERCENTAGE } from "./stripe";

export const FULL_BASIS_POINTS = 10_000;

export const MARKETPLACE_MARGIN_FLOOR_PERCENT = 20;

export const MARKETPLACE_COST_SHARE_BASIS_POINTS =
  FULL_BASIS_POINTS -
  MARKETPLACE_MARGIN_FLOOR_PERCENT * 100 -
  Math.round(STRIPE_BASE_PERCENTAGE * 100);

export const DEFAULT_EFFECTIVE_RATE =
  FULL_BASIS_POINTS / MARKETPLACE_COST_SHARE_BASIS_POINTS - 1;

export const EFFECTIVE_FEE_RATES: Record<SubscriptionTier, number> = {
  free: DEFAULT_EFFECTIVE_RATE,
  starter: DEFAULT_EFFECTIVE_RATE,
  pro: DEFAULT_EFFECTIVE_RATE,
  enterprise: DEFAULT_EFFECTIVE_RATE,
} as const;

export function getEffectiveFeeRate(tier: SubscriptionTier): number {
  return EFFECTIVE_FEE_RATES[tier] ?? DEFAULT_EFFECTIVE_RATE;
}

export const FREIGHT_MARGIN_RATE = 0.05;

export const CURRI_QUOTE_PAD_RATE = 0.1;

export const MS_PER_DAY = 24 * 60 * 60 * 1000;

export const ADMIN_QUOTE_MARGIN_TIERS: readonly MarginTier[] = [
  { name: "Break Even", percent: 0 },
  { name: "Low (10%)", percent: 10 },
  { name: "Low (15%)", percent: 15 },
  { name: "Target (20%)", percent: 20 },
  { name: "High (25%)", percent: 25 },
] as const;

export const DEFAULT_ADMIN_MARGIN_PERCENT = 20;

export const ADMIN_QUOTE_COMMISSION_RATE = 0.15;

export const ADMIN_QUOTE_EXPIRY_DAYS = 14;

export const MARGIN_THRESHOLD_DANGER = 10;
export const MARGIN_THRESHOLD_WARNING = 20;
